import { NODE_TYPES } from "constants/flowDesigner";

const labelComponentMockData = {
  type: NODE_TYPES.LABEL,
  key: NODE_TYPES.LABEL,
  name: NODE_TYPES.LABEL,
  actions: [
    {
      actionID: "LC_0",
      actionName: "Label Name",
      dataInsideAction: [
        {
          field: "labelName",
          label: "Branch Label",
          type: "text",
          value: "",
        },
      ],
    }
  ]
};

export default labelComponentMockData;